import { useQuery } from 'react-query';
import { CustomUseQueryOptions } from './requests-types/custom-use-query-options';
import { getPrivateApi } from '../../services/api';
import {
  ContractPageVersion,
  GetContractVersionResponse,
  GetContractVersionResponseSchema,
} from '@vy/api-definition';
import { last } from '@vy/utils';
import { useStateParams } from '../use-state-params';
import { queryKeys } from '../../services/query-key/query-keys';

export function useContractVersion(
  contractId: string,
  versionId?: string,
  options?: CustomUseQueryOptions<GetContractVersionResponse>,
) {
  return useQuery(
    queryKeys.contractVersion(contractId, versionId),
    async () => {
      const api = getPrivateApi();

      const getContractVersionResponse = await api.getContractVersion({
        contractId,
        versionId,
      });

      return GetContractVersionResponseSchema.parse(getContractVersionResponse);
    },
    {
      ...options,
    },
  );
}

export function useContractVersionStateParam(versions: ContractPageVersion[] | undefined = []) {
  const latestVersionId = last(versions)?.revisionId;

  return useStateParams(
    latestVersionId,
    'versionId',
    (versionId) => versionId,
    (versionId) => versionId,
  );
}
